import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { LegacyInputTextComponent, FormikChips, FormikCheckbox } from '../../../components/prime-formik';
import { intlShape, formikFormShape } from '../../../components/prop-types';
import { renderAsyncSelector } from '../../../components/formik-components/FormAsyncSelector';

const i18n = defineMessages({
  name: {
    id: 'attrs.name',
    defaultMessage: 'Name',
  },
  commentEnable: {
    id: '360.comments.status',
    defaultMessage: 'Allow comments?',
  },
  allowComment: {
    id: '360.comments.enabled',
    defaultMessage: 'Comments allowed',
  },
  nowAllowComment: {
    id: '360.comments.disabled',
    defaultMessage: 'Comments not allowed',
  },
  choose: {
    id: 'choose',
    defaultMessage: 'Choose',
  },
  tag: {
    id: 'attrs.tags',
    defaultMessage: 'Tags',
  },
});

const NewSurveyForm = (props) => {
  const {
    formProps: { setFieldValue },
    intl: { formatMessage },
    processing,
    surveyTemplates,
    searchTemplate,
  } = props;

  const namePlaceholder = formatMessage(i18n.name);
  const allowCommentText = formatMessage(i18n.allowComment);
  return (
    <>
      <div className="p-grid p-fluid">
        <div className="p-md-6 p-sm-12">
          <label className="field-label" htmlFor="name">
            <FormattedMessage id="360.name" defaultMessage="Survey name" />
          </label>
          <Field type="text" name="name" id="name" placeholder={namePlaceholder} component={LegacyInputTextComponent} />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-md-6 p-sm-12">
          <label className="field-label" htmlFor="surveyTemplate">
            <FormattedMessage id="attrs.survey_template" defaultMessage="Survey Template" />
          </label>
          <Field
            id="surveyTemplate"
            name="surveyTemplate"
            component={renderAsyncSelector}
            processing={processing}
            data={surveyTemplates}
            filter
            valueField="id"
            textField="title"
            onSearch={searchTemplate}
            setFieldValue={setFieldValue}
            placeholder={`- ${formatMessage(i18n.choose)} -`}
          />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-md-6 p-sm-12">
          <label className="field-label" htmlFor="eval-360-tags">
            <FormattedMessage id="360.tags" defaultMessage="Survey tags" />
          </label>
          <Field id="tags" name="tags" component={FormikChips} setFieldValue={setFieldValue} addOnBlur />
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-12">
          <Field
            id="commentsEnabled"
            name="commentsEnabled"
            component={FormikCheckbox}
            labelText={allowCommentText}
            setFieldValue={setFieldValue}
          />
        </div>
      </div>
    </>
  );
};

NewSurveyForm.propTypes = {
  intl: intlShape.isRequired,
  formProps: formikFormShape.isRequired,
  processing: PropTypes.bool.isRequired,
  searchTemplate: PropTypes.func.isRequired,
  surveyTemplates: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default injectIntl(NewSurveyForm);
